import React from 'react';
import { FormattedMessage } from 'react-intl';

const TwoFactorActivateBlockGuildeSms = ({ phone }) => {
  return (
    <p className="two-factor-activate-block-title">
      <FormattedMessage
        id="pages.profile.security.activate.title.sms"
        defaultMessage="We sent a 6-digit code to number { number }. Enter it in the field below."
        values={{ number: phone }}
      />
    </p>
  );
};

export default TwoFactorActivateBlockGuildeSms;
